import { IAppState } from '../../redux';
import { selectActiveService } from './selectActiveService';

export function selectActivePeriodId(state: IAppState): string | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { selectedPeriodId },
  } = selectedService;

  return selectedPeriodId;
}
